export default "__VITE_ASSET__D56JaPfw__"